import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { LanguageProvider } from './context/LanguageContext';
import HomePage from './pages/HomePage';
import ServiciosPage from './pages/ServiciosPage';
import NosotrosPage from './pages/NosotrosPage';
import ContactoPage from './pages/ContactoPage';
import MobileFixedCTA from './components/MobileFixedCTA';
import './App.css';

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/servicios" element={<ServiciosPage />} />
            <Route path="/nosotros" element={<NosotrosPage />} />
            <Route path="/contacto" element={<ContactoPage />} />
          </Routes>
          <MobileFixedCTA />
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </LanguageProvider>
    </div>
  );
}

export default App;